import { HTMLAttributes } from 'react'
import { cva, VariantProps } from 'class-variance-authority'

import Section from '@/components/base/Section'

import { cn } from '@/lib/utils'

const spacerVariants = cva(['border-0'], {
  variants: {
    variant: {
      xxs: 'pt-[0.8rem] md:pt-[1.6rem]',
      xs: 'pt-[1.6rem] md:pt-[3.2rem]',
      sm: 'pt-[2.4rem] md:pt-[4.8rem]',
      md: 'pt-[3.2rem] md:pt-[6.4rem]',
      lg: 'pt-[4rem] md:pt-[8rem]',
      xl: 'pt-[4.8rem] md:pt-[9.6rem]',
      xxl: 'pt-[6rem] md:pt-[12rem]'
    },
    theme: {
      transparent: 'bg-transparent',
      light: 'bg-background',
      dark: 'bg-primary'
    }
  },
  defaultVariants: {
    variant: 'md',
    theme: 'light'
  }
})

export type SpacerProps = HTMLAttributes<HTMLHRElement> &
  VariantProps<typeof spacerVariants>

const Spacer = ({
  className,
  variant,
  theme = 'light',
  ...props
}: SpacerProps) => {
  return (
    <Section
      asChild
      className={cn(
        spacerVariants({ variant, theme, className }),
        'relative z-0'
      )}
      {...props}
    >
      <hr />
    </Section>
  )
}

export default Spacer
